import { Component } from 'react'
import { ErrorMessage, emptyField, errorsLength, formatErrors } from '../../../../../insfrastructure/utils/form-validators'
import { StaticValues } from '../../../../../insfrastructure/services/static_values'
import { listCourses } from '../../../../../insfrastructure/services/courses'
import { MultiSelect } from '../../../../components/multi-select'
import { Select } from '../../../../components/select'
import { Input } from '../../../../components/input'
import './styles.sass'

interface Props {
  inital_data?: any,
  onSubmit: (data: any) => void
}

export interface RequirementsForm {
  minimum_education: string,
  minimum_experience: string,
  recommended_courses: number[],
  required_skills: { skill_id: number, skill_type: string }[],
  desired_skills: { skill_id: number, skill_type: string }[]
}

interface State {
    form: RequirementsForm,
    formErrors: Record<string, any>,
    schoolarship_options: [], 
    courses_options: any[], 
    experiences_options: { label: string, value: string }[], 
    skills_options: { value: any, label: string, skill_id: number, skill_type: string }[], 
    show_new_course_form: boolean,
    new_course: Record<string, any>,
    new_course_form_errors: Record<string, any>,
    show_new_hability_form: boolean,
    new_hability: Record<string, any>,
    new_hability_form_errors: Record<string, any>
  }

export default class Requirements extends Component<Props> {
  state: State = {
    form: {
      minimum_education: '',
      minimum_experience: '0',
      recommended_courses: [],
      required_skills: [],
      desired_skills: []
    },
    formErrors: {},
    schoolarship_options: [], 
    courses_options: [], 
    experiences_options: [
      {
        label: 'Indiferente',
        value: '0'
      },
      {
        label: 'Pelo menos 1 ano',
        value: '1'
      },
      {
        label: 'Pelo menos 2 anos',
        value: '2'
      },
      {
        label: 'Pelo menos 3 anos',
        value: '3'
      },
      {
        label: 'Pelo menos 4 anos',
        value: '4'
      },
      {
        label: 'Pelo menos 5 anos',
        value: '5'
      }
    ], 
    skills_options: [], 
    show_new_course_form: false,
    new_course: {},
    new_course_form_errors: {},
    show_new_hability_form: false,
    new_hability: {},
    new_hability_form_errors: {}
  }

  componentDidMount() {
    if(this.props.inital_data) {
      this.setState({ form: {
        ...this.state.form,
        ...this.props.inital_data
      } });
    };
    this.getStaticValues();
    // this.listCourses();
  }

  getStaticValues = async () => {
    try {  
      const staticValues = JSON.parse(localStorage.getItem('static_values')+'') as StaticValues;          
      const schoolarship_options = Object.keys(staticValues.education_level).map(key => ({ value: key, label: staticValues.education_level[key] }));
      const skills_options = staticValues.skills.map(skill => ({ value: skill.id, label: skill.name, skill_type: skill.category }));
      const courses_options = Object.keys(staticValues.em_course).map(key => ({ value: parseInt(key), label: staticValues.em_course[key] }));
      
      this.setState({ schoolarship_options, skills_options, courses_options });
    } catch (error) {}
  }

  async listCourses() {
    try {
      const results = await listCourses();

      const courses_options = results.results.map(item => {    
        return {
          value: item.id,
          label: item.course_name
        };
      });

      this.setState({ courses_options });
    } catch (error) {}
  }

  toggleCourseForm = () => {
    this.setState({ show_new_course_form: !this.state.show_new_course_form, new_course: {} });
  }

  onSubmitCourse = () => {
    const errors = formatErrors({
      name: [emptyField(this.state.new_course.name, 'string')]
    });

    this.setState({ new_course_form_errors: errors });

    if(errorsLength(errors) > 0) return;

    this.setState({ 
      courses_options: [ ...this.state.courses_options, { label: this.state.new_course.name, value: this.state.new_course.name } ], 
      show_new_course_form: false,
      new_course: null
    });
  }

  toggleHabilityForm = () => {
    this.setState({ show_new_hability_form: !this.state.show_new_hability_form, new_hability: {} });
  }

  onSubmitHability = () => {
    const errors = formatErrors({
      name: [emptyField(this.state.new_hability.name, 'string')]
    });

    this.setState({ new_hability_form_errors: errors });

    if(errorsLength(errors) > 0) return;

    this.setState({ 
      skills_options: [ ...this.state.skills_options, { label: this.state.new_hability.name, value: this.state.new_hability.name } ], 
      show_new_hability_form: false,
      new_hability: null
    });
  }

  onRequiredSkillsChange = (selectedSkills: any[]) => {
    this.setState({ 
      form: { 
        ...this.state.form, 
        required_skills: selectedSkills
      } 
    });
  }

  onDesiredSkillsChange = (selectedSkills: any[]) => {
    this.setState({ 
      form: { 
        ...this.state.form, 
        desired_skills: selectedSkills
      } 
    });
  }

  // Filtrar opções disponíveis para required_skills (excluir habilidades já selecionadas em desired_skills)
  getAvailableRequiredSkills = () => {
    return this.state.skills_options.filter(
      (skill: any) => !this.state.form.desired_skills.includes(skill.value)
    );
  }

  // Filtrar opções disponíveis para desired_skills (excluir habilidades já selecionadas em required_skills)
  getAvailableDesiredSkills = () => {
    return this.state.skills_options.filter(
      (skill: any) => !this.state.form.required_skills.includes(skill.value)
    );
  }

  onSubmit = () => {
    // const errors = formatErrors({
    // });

    // this.setState({ formErrors: errors });

    // if(errorsLength(errors) > 0) return;

    // Manter required_skills e desired_skills como arrays de IDs (números)
    // O summary vai construir o array skills no formato correto
    const form = {
      ...this.state.form,
      required_skills: this.state.form.required_skills.filter((id: any) => id !== null && id !== undefined),
      desired_skills: this.state.form.desired_skills.filter((id: any) => id !== null && id !== undefined),
      // Converter recommended_courses para array de inteiros e filtrar valores vazios e NaN
      recommended_courses: this.state.form.recommended_courses
        .filter((course: any) => course && course !== '') // Filtrar valores vazios
        .map((course: any) => parseInt(course))
        .filter((course: number) => !isNaN(course)) // Filtrar valores NaN
    };

    this.props.onSubmit(form);
  }

  render() {
    return (
      <div className='requirements'>
        <div className='columns'>
          <div className='column'>
            <div>
              <Select
              name='minimum_education'
              label='Escolaridade'
              value={this.state.form.minimum_education}
              options={this.state.schoolarship_options}
              onChange={e => this.setState({ form: { ...this.state.form, minimum_education: e } })}/>
            </div>
            <div className='requirement-section'>
              <MultiSelect
              name='recommended_courses'
              label='Cursos desejáveis'
              value={this.state.form.recommended_courses}
              options={this.state.courses_options}
              onChange={e => this.setState({ form: { ...this.state.form, recommended_courses: e } })}/>
              {this.state.show_new_course_form &&
              <div className='course-form'>
                <Input
                name='name'
                label='Nome'
                onChange={e => this.setState({ new_course: { ...this.state.new_course, name: e } })}/>
                <ErrorMessage errors={this.state.new_course_form_errors['name']} />
                <div className='columns'>
                  <button className='secondary' onClick={this.onSubmitCourse}>Salvar</button>
                  <button className='cancel' onClick={this.toggleCourseForm}>Cancelar</button>
                </div>
              </div>}
              {/* {!this.state.show_new_course_form &&
              <button className='secondary toggle-course-form' onClick={this.toggleCourseForm}>
                <img src={addImg} alt='add-icon' />
                <span>Adicionar Curso</span>
              </button>} */}
            </div>
            <div>
              <Select
              name='minimum_experience'
              label='Experiência mínima'
              value={this.state.form.minimum_experience}
              options={this.state.experiences_options}
              onChange={e => this.setState({ form: { ...this.state.form, minimum_experience: e } })}/>
            </div>
          </div>
          <div className='column'>
            <div className='requirement-section'>
              <MultiSelect
              name='required_skills'
              label='Habilidades obrigatórias'
              value={this.state.form.required_skills}
              options={this.getAvailableRequiredSkills()}
              onChange={e => this.onRequiredSkillsChange(e)}/>
              {this.state.show_new_hability_form &&
              <div className='course-form'>
                <Input
                name='name'
                label='Nome'
                onChange={e => this.setState({ new_hability: { ...this.state.new_hability, name: e } })}/>
                <ErrorMessage errors={this.state.new_hability_form_errors['name']} />
                <div className='columns'>
                  <button className='secondary' onClick={this.onSubmitHability}>Salvar</button>
                  <button className='cancel' onClick={this.toggleHabilityForm}>Cancelar</button>
                </div>
              </div>}
              {/* {!this.state.show_new_hability_form &&
              <button className='secondary toggle-course-form' onClick={this.toggleHabilityForm}>
                <img src={addImg} alt='add-icon' />
                <span>Adicionar Habilidade</span>
              </button>} */}
            </div>
            <div className='requirement-section'>
              <MultiSelect
              name='desired_skills'
              label='Habilidades opcionais'
              value={this.state.form.desired_skills}
              options={this.getAvailableDesiredSkills()}
              onChange={e => this.onDesiredSkillsChange(e)}/>
              {this.state.show_new_hability_form &&
              <div className='course-form'>
                <Input
                name='name'
                label='Nome'
                onChange={e => this.setState({ new_hability: { ...this.state.new_hability, name: e } })}/>
                <ErrorMessage errors={this.state.new_hability_form_errors['name']} />
                <div className='columns'>
                  <button className='secondary' onClick={this.onSubmitHability}>Salvar</button>
                  <button className='cancel' onClick={this.toggleHabilityForm}>Cancelar</button>
                </div>
              </div>}
              {/* {!this.state.show_new_hability_form &&
              <button className='secondary toggle-course-form' onClick={this.toggleHabilityForm}>
                <img src={addImg} alt='add-icon' />
                <span>Adicionar Habilidade</span>
              </button>} */}
            </div>
          </div>
        </div>
        <button className='primary' onClick={this.onSubmit}>Confirmar</button>
      </div>
    )
  }
}
